type Params = {
  projectId: string;
  merchantId: number;
  locale: string;
  socialName: string;
};

const getTryConnectionLink = ({ projectId, locale, socialName, merchantId }: Params): string => {
  const mainParams = new URLSearchParams();
  const extraParams = new URLSearchParams();

  extraParams.append('locale', locale);
  extraParams.append('social_name', socialName);
  extraParams.append('project_id', projectId);
  extraParams.append('merchant_id', merchantId.toString());

  mainParams.append('projectId', projectId);
  mainParams.append(
    'login_url',
    `https://login-publisher.xsolla.com/social_auth?${extraParams.toString()}`
  );

  return `${
    process.env.LOGIN_API_URL
  }/social/${socialName}/login_redirect?${mainParams.toString()}`;
};

export default getTryConnectionLink;
